import { useSelector } from 'react-redux';
import Box from 'fe-design-base/atoms/Box';
import Icon from 'fe-design-base/atoms/Icon';
import Text from 'fe-design-base/atoms/Text';
import Link from 'fe-design-base/molecules/Link';

import { getShowPreNoteValidationBanner } from 'features/payroll/redux/selectors/payroll';

import { cxHelpers } from 'util/className';
import { toI18n } from 'util/i18n';

const { cx, cxEl } = cxHelpers('PayrollPreNoteValidationBanner');

const PayrollPreNoteValidationBanner = () => {
  const showPreNoteValidationBanner = useSelector(
    getShowPreNoteValidationBanner
  );

  if (!showPreNoteValidationBanner) return null;

  return (
    <Box className={cx()}>
      <Box
        row
        h={44}
        vcenter
        hcenter
        bgcolor="error100"
        className={cxEl('text')}
        gap={8}
      >
        <Icon iconName="Critical" size="medium" color="error300" />
        <Text
          color="mono900"
          i18n="payroll.dashboard.pre_note_validation.text"
          variant="bodySmBoldTight"
        />
        <Link href="/payroll/pre_note_validation_handler" size="small">
          {toI18n('payroll.dashboard.pre_note_validation.cta')}
        </Link>
      </Box>
    </Box>
  );
};

export default PayrollPreNoteValidationBanner;
